import axios from 'axios'

function createNetworkClient(params) {
    const networkClient = axios.create(params)

    return networkClient
}

async function subscribeEmailToFoodNerdList(email) {
    var bodyFormData = new FormData()
    bodyFormData.append('g', 'MuUynB')
    bodyFormData.append('email', email)
    bodyFormData.append("$fields", "$source")
    bodyFormData.append("$source", "API_ALI")

    try {
        await axios.post(
            'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
            bodyFormData
        )
        const networkClient = createNetworkClient({
            baseURL: 'https://manage.kmail-lists.com',
            timeout: 10000,
        })
        await networkClient.post('/ajax/subscriptions/subscribe', bodyFormData)
    } catch (error) {
        console.log(error)
    }
}

export function marketingEmailOptInUser(email) {
    const marketingEmailOptInUser = localStorage.getItem('marketingEmailOptInUser');

    if (email && marketingEmailOptInUser === 'true') {
        subscribeEmailToFoodNerdList(email)
    }
}
